import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.137 3.464c.707-.2 1.415-.23 2.072-.208 1.054.03 2.415.212 3.371 1.143l.006.006c.676.673 1.133 1.706 1.158 2.674v.004c.02.976-.01 1.951-.081 2.913l-.015.216c-.061.851-.136 1.906-.537 2.838l-.001.002a4.544 4.544 0 0 1-1.233 1.65l.3 1.798 5.658 2.83-.67 1.34-6.342-3.17-.332-1.994a4.459 4.459 0 0 1-2.978-.024l-.336 2.018-6.342 3.17-.67-1.34 5.658-2.83.302-1.813a4.3 4.3 0 0 1-.844-.955 4.302 4.302 0 0 1-.567-1.233 11.116 11.116 0 0 1-.244-1.178l-.001-.009c-.146-.98-.186-1.97-.205-2.917v-.003l-.006-.246c-.013-.488-.028-1.06.102-1.65.133-.607.377-1.273.835-1.827l.004-.006c.524-.621 1.23-.999 1.938-1.2Zm2.025 1.291c-.586-.019-1.12.012-1.616.152-.494.14-.911.382-1.197.72-.251.306-.42.72-.524 1.191v.002c-.088.395-.08.763-.068 1.253.002.093.005.19.006.292.02.933.059 1.843.189 2.723.057.358.121.697.209 1.017l.001.005c.073.272.199.529.379.807.824 1.274 2.605 1.715 3.898.969l.003-.002a3.089 3.089 0 0 0 1.291-1.428c.296-.688.355-1.496.422-2.406l.012-.164c.068-.919.096-1.846.077-2.77-.015-.572-.306-1.238-.713-1.645-.524-.508-1.37-.687-2.367-.716z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }